import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import LiveChat from 'components/LiveChat';
import { DetailsBookingProvider } from 'hooks/useDetailsBooking';

interface BookingRouteProps extends Omit<RouteProps, 'render' | 'component' | 'children'> {
  component: React.ComponentType<any>;
}

const BookingRoute: React.FC<BookingRouteProps> = ({ component: Component, ...routeProps }) => {
  return (
    <Route
      {...routeProps}
      render={(props) => (
        <DetailsBookingProvider>
          <Component {...props} />
          <LiveChat />
        </DetailsBookingProvider>
      )}
    />
  );
};

export default BookingRoute;
